/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var encodeFormData = function (data) {
    return Object.keys(data)
        .filter(function (key) { return Boolean(data[key]); })
        .map(function (key) { return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(data[key])); })
        .join('&');
};
function buildOneTimeCodeTokenRequest(otc, issuer) {
    // eslint-disable-next-line no-restricted-globals
    var otcUrl = new URL("".concat(issuer, "/one-time-code"), location.origin);
    var request = new Request(otcUrl.href, {
        method: 'put',
        body: JSON.stringify({ otc: otc }),
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    });
    return request;
}
function buildClaimUserTokenRequest(userId, app, token, issuer) {
    // eslint-disable-next-line no-restricted-globals
    var claimUserUrl = new URL("".concat(issuer, "/login-user/").concat(userId), location.origin);
    var request = new Request(claimUserUrl.href, {
        method: 'put',
        headers: { 'Content-Type': 'application/json', Authorization: "Bearer ".concat(token) },
        body: JSON.stringify({ app: app }),
        credentials: 'include',
    });
    return request;
}
function buildMigrationStateAppendUserIdRequest(token, issuer, state) {
    var params = {
        state: state,
    };
    var authParams = encodeFormData(params);
    // eslint-disable-next-line no-restricted-globals
    var authUrl = new URL("".concat(issuer, "/migration-state-append-user-id"), location.origin);
    authUrl.search = authParams;
    var request = new Request(authUrl.href, {
        method: 'get',
        headers: {
            Accept: 'application/json',
            Authorization: "Bearer ".concat(token),
        },
        credentials: 'include',
    });
    return request;
}
function buildAuthorizeUrl(clientId, issuer, redirectUri, state, codeChallenge, scope, role, landingPage) {
    var params = {
        client_id: clientId,
        code_challenge: codeChallenge,
        code_challenge_method: 'S256',
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: scope !== undefined ? scope : 'vis',
        state: state,
        role: role !== undefined ? role : false,
        landingpage: landingPage !== undefined ? landingPage : 'signIn',
    };
    var authParams = encodeFormData(params);
    // eslint-disable-next-line no-restricted-globals
    var authUrl = new URL("".concat(issuer, "/authorize"), location.origin);
    authUrl.search = authParams;
    return authUrl.href;
}
function buildTokenRequest(clientId, issuer, redirectUri, code, codeVerifier, scope, state) {
    var body = {
        grant_type: 'authorization_code',
        code: code,
        client_id: clientId,
        code_verifier: codeVerifier,
        redirect_uri: redirectUri,
        scope: scope !== undefined ? scope : 'vis',
        state: state !== null && state !== void 0 ? state : false,
    };
    var request = new Request("".concat(issuer, "/token"), {
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
        },
        credentials: 'include',
        body: encodeFormData(body),
    });
    return request;
}
function buildOidcAuthorizePasswordRequest(params) {
    var clientId = params.clientId, redirectUri = params.redirectUri, username = params.username, password = params.password, codeChallenge = params.codeChallenge, scope = params.scope, state = params.state;
    var body = {
        code_challenge_method: 'S256',
        username: username,
        password: password,
        client_id: clientId,
        redirect_uri: redirectUri,
        code_challenge: codeChallenge,
        scope: scope !== undefined ? scope : 'vis',
        state: state !== null && state !== void 0 ? state : false,
    };
    var request = new Request('/api/users/oidc/authorize', {
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
        },
        credentials: 'include',
        body: encodeFormData(body),
    });
    return request;
}
function buildGetTokenInfoRequest(token) {
    var request = new Request("/api/token_info", {
        method: 'get',
        headers: {
            Accept: 'application/json',
            Authorization: "Bearer ".concat(token),
        },
        credentials: 'include',
    });
    return request;
}
function buildRefreshSessionRequest(token, refreshUri) {
    var request = new Request(refreshUri, {
        method: 'get',
        headers: {
            Accept: 'application/json',
            Authorization: "Bearer ".concat(token),
        },
        credentials: 'include',
    });
    return request;
}
function buildMFALogoutUrl(loginDotGovUrl, clientId, postLogoutRedirectUri, state) {
    var params = {
        client_id: clientId,
        post_logout_redirect_uri: postLogoutRedirectUri,
        state: state !== null && state !== void 0 ? state : false,
    };
    var mfaLogoutUrl = new URL("".concat(loginDotGovUrl, "/openid_connect/logout"));
    mfaLogoutUrl.search = encodeFormData(params);
    return mfaLogoutUrl.href;
}
function generateRandomString() {
    var array = new Uint32Array(28);
    // @ts-ignore
    var crypto = globalThis.crypto || globalThis.msCrypto;
    crypto.getRandomValues(array);
    return Array.from(array, function (dec) { return "0".concat(dec.toString(16)).substr(-2); }).join('');
}
function textEncode(str) {
    if (window.TextEncoder) {
        return new TextEncoder().encode(str);
    }
    var bytes = new Uint8Array(str.length);
    // eslint-disable-next-line no-plusplus
    for (var iii = 0; iii < str.length; iii++) {
        bytes[iii] = str.charCodeAt(iii);
    }
    return bytes;
}
function sha256(str) {
    // @ts-ignore
    if (typeof globalThis.msCrypto === 'object') {
        // for IE11
        return new Promise(function (resolve) {
            /* eslint-disable */
            // @ts-ignore
            var res = globalThis.msCrypto.subtle.digest('SHA-256', textEncode(str));
            res.oncomplete = function (e) {
                var _a;
                // @ts-ignore
                resolve((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.result);
            };
            /* eslint-enable */
        });
    }
    return crypto.subtle.digest('SHA-256', textEncode(str));
}
function base64urlencode(str) {
    // Convert the ArrayBuffer to string using Uint8 array to convert to what btoa accepts.
    // btoa accepts chars only within ascii 0-255 and base64 encodes them.
    // Then convert the base64 encoded to base64url encoded
    //   (replace + with -, replace / with _, trim trailing =)
    var int8Array = new Uint8Array(str);
    var intArray = Array.from(int8Array);
    return btoa(String.fromCharCode.apply(null, intArray)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function pkceChallengeFromVerifier(v) {
    return __awaiter(this, void 0, void 0, function () {
        var hashed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sha256(v)];
                case 1:
                    hashed = _a.sent();
                    return [2 /*return*/, base64urlencode(hashed)];
            }
        });
    });
}
function generatePkceCodes() {
    return __awaiter(this, void 0, void 0, function () {
        var codeState, codeVerifier, codeChallenge;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    codeState = generateRandomString();
                    codeVerifier = generateRandomString();
                    return [4 /*yield*/, pkceChallengeFromVerifier(codeVerifier)];
                case 1:
                    codeChallenge = _a.sent();
                    return [2 /*return*/, { codeState: codeState, codeVerifier: codeVerifier, codeChallenge: codeChallenge }];
            }
        });
    });
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var js_cookie = createCommonjsModule(function (module, exports) {
(function (factory) {
	var registeredInModuleLoader;
	{
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));
});

/* eslint-disable class-methods-use-this */
var CookieStorage = /** @class */ (function () {
    function CookieStorage() {
        var _this = this;
        this.cookie = js_cookie;
        this.clear = function () {
            throw new Error('Method not implemented.');
        };
        this.getItem = function (key) {
            return _this.cookie.get(key) || null;
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.key = function (_) {
            throw new Error('Method not implemented.');
        };
        this.removeItem = function (key) {
            _this.cookie.remove(key);
        };
        this.setItem = function (key, value) {
            _this.cookie.set(key, value, { secure: window.location.protocol === 'https:', expires: 1 });
        };
    }
    Object.defineProperty(CookieStorage.prototype, "length", {
        get: function () {
            return Object.keys(this.cookie.get()).length;
        },
        enumerable: false,
        configurable: true
    });
    return CookieStorage;
}());

var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        var _this = this;
        this.storage = new Map();
        this.clear = function () {
            _this.storage.clear();
        };
        this.getItem = function (key) {
            return _this.storage.get(key) || null;
        };
        // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
        this.key = function (_) {
            throw new Error('Method not implemented.');
        };
        this.removeItem = function (key) {
            _this.storage.delete(key);
        };
        this.setItem = function (key, value) {
            _this.storage.set(key, value);
        };
    }
    Object.defineProperty(MemoryStorage.prototype, "length", {
        get: function () {
            return this.storage.size;
        },
        enumerable: false,
        configurable: true
    });
    return MemoryStorage;
}());

var tokenStorageKey = '_auth_token';
var userStorageKey = '_auth_user';
/** Storage Key for the desired secure route before and after redirects */
var secureRouterReferrerPath = '_secureRouterReferrerPath';
/** Storage Key for PKCE */
var pkceCodeKey = '_pkce';
/** Storage Key for sessionStorage tabId */
var tabIdKey = '_auth-client-tabId';
/** Cross tabId | needed when a user creates a new LDG account and opens a new tab */
var crossTabIdKey = 'cross-tab-id';
var StorageService = /** @class */ (function () {
    function StorageService(tokenStorage) {
        switch (tokenStorage) {
            case 'local':
                this.tokenStorage = window.localStorage;
                break;
            case 'session':
                this.tokenStorage = window.sessionStorage;
                break;
            case 'cookie':
                this.tokenStorage = new CookieStorage();
                break;
            case 'memory':
            default:
                this.tokenStorage = new MemoryStorage();
                break;
        }
        this.pkceStorage = localStorage;
        this.tabId = sessionStorage.getItem(tabIdKey) || '';
        if (!this.tabId) {
            this.tabId = Math.random().toString();
            sessionStorage.setItem(tabIdKey, this.tabId);
        }
    }
    StorageService.prototype.setToken = function (value) {
        this.tokenStorage.setItem(tokenStorageKey, value);
    };
    StorageService.prototype.getToken = function () {
        return this.tokenStorage.getItem(tokenStorageKey);
    };
    StorageService.prototype.removeToken = function () {
        this.tokenStorage.removeItem(tokenStorageKey);
    };
    StorageService.prototype.setUser = function (value) {
        this.tokenStorage.setItem(userStorageKey, JSON.stringify(value));
    };
    StorageService.prototype.getUser = function () {
        var storedUser = this.tokenStorage.getItem(userStorageKey);
        if (storedUser) {
            return JSON.parse(storedUser);
        }
        return null;
    };
    StorageService.prototype.removeUser = function () {
        this.tokenStorage.removeItem(userStorageKey);
    };
    StorageService.prototype.getKeyWithTabId = function (key, tabId) {
        if (tabId === void 0) { tabId = this.tabId; }
        return "".concat(key, ":").concat(tabId);
    };
    StorageService.prototype.setSecureRouterReferrerPath = function (localPath) {
        this.pkceStorage.setItem(this.getKeyWithTabId(secureRouterReferrerPath), localPath);
    };
    StorageService.prototype.removeSecureRouterReferrerPath = function () {
        var location = this.pkceStorage.getItem(this.getKeyWithTabId(secureRouterReferrerPath)) || '/';
        this.pkceStorage.removeItem(this.getKeyWithTabId(secureRouterReferrerPath));
        return location;
    };
    StorageService.prototype.setPkceCodes = function (codes, storeCrossTabId) {
        if (storeCrossTabId === void 0) { storeCrossTabId = false; }
        if (storeCrossTabId) {
            this.pkceStorage.setItem(crossTabIdKey, this.tabId);
        }
        this.pkceStorage.setItem(this.getKeyWithTabId(pkceCodeKey), JSON.stringify(codes));
    };
    StorageService.prototype.removePkceCodes = function () {
        var crossTabId = this.pkceStorage.getItem(crossTabIdKey);
        var pkceStringCrossTab = this.pkceStorage.getItem(this.getKeyWithTabId(pkceCodeKey, crossTabId !== null && crossTabId !== void 0 ? crossTabId : undefined));
        var pkceString = this.pkceStorage.getItem(this.getKeyWithTabId(pkceCodeKey));
        console.log('STORAGE STRINGS', pkceString, pkceStringCrossTab);
        console.log('IDSSS :', crossTabId, this.getKeyWithTabId(pkceCodeKey));
        this.pkceStorage.removeItem(this.getKeyWithTabId(pkceCodeKey));
        this.tokenStorage.removeItem(crossTabIdKey);
        // On first load there will not be a pkce code, so we'll look for the crossTab one if it esists
        return JSON.parse(pkceString || pkceStringCrossTab || '{}');
    };
    return StorageService;
}());

var AuthErrorName = 'Authentication Error';
var AuthError = /** @class */ (function (_super) {
    __extends(AuthError, _super);
    function AuthError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = AuthErrorName;
        return _this;
    }
    return AuthError;
}(Error));

/* eslint-disable camelcase */
var AuthStates;
(function (AuthStates) {
    AuthStates["authenticated"] = "authenticated";
    AuthStates["unauthenticated"] = "unauthenticated";
    AuthStates["authenticating"] = "authenticating";
    AuthStates["logout"] = "logout";
})(AuthStates || (AuthStates = {}));
var SessionStates;
(function (SessionStates) {
    SessionStates["none"] = "none";
    SessionStates["valid"] = "valid";
    SessionStates["warning"] = "warning";
    SessionStates["timeout"] = "timeout";
})(SessionStates || (SessionStates = {}));

var sessionTimerKey = '_auth-client-timer';
var SessionTimer = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function SessionTimer(config, countdownInterval) {
        if (countdownInterval === void 0) { countdownInterval = 1000; }
        this.config = config;
        this.countdownInterval = countdownInterval;
    }
    SessionTimer.prototype.clearSessionTimers = function (windowBlur) {
        if (windowBlur === void 0) { windowBlur = false; }
        clearTimeout(this.timer);
        clearInterval(this.interval);
        if (!windowBlur) {
            localStorage.removeItem(sessionTimerKey);
        }
    };
    SessionTimer.prototype.setupWarningInterval = function (timeout, onUpdate, onTimeout) {
        var _this = this;
        var timeLeft = timeout;
        onUpdate(timeLeft);
        this.interval = window.setInterval(function () {
            timeLeft -= _this.countdownInterval;
            if (timeLeft > 0) {
                onUpdate(timeLeft);
            }
            else {
                _this.clearSessionTimers();
                onTimeout();
            }
        }, this.countdownInterval);
    };
    SessionTimer.prototype.setupSessionWarning = function (onUpdate, onTimeout) {
        var _this = this;
        var _a = this.config, timeout = _a.timeout, warning = _a.warning;
        this.clearSessionTimers();
        localStorage.setItem(sessionTimerKey, new Date().getTime().toString());
        this.timer = window.setTimeout(function () {
            _this.setupWarningInterval(timeout, onUpdate, onTimeout);
        }, warning);
    };
    SessionTimer.prototype.restoreSessionTimer = function (onUpdate, onTimeout) {
        var _this = this;
        var timeout = this.config.timeout;
        var warningTimeLeft = this.getWarningTimeLeft();
        // check if time left before warning timeout should show.
        if (warningTimeLeft > 0) {
            this.timer = window.setTimeout(function () {
                _this.setupWarningInterval(timeout, onUpdate, onTimeout);
            }, warningTimeLeft);
            return SessionStates.valid;
        }
        var timeoutTimeLeft = this.getSessionTimeoutLeft();
        // check if time in left in timeout warning
        if (timeoutTimeLeft > 0) {
            this.setupWarningInterval(timeoutTimeLeft, onUpdate, onTimeout);
            return SessionStates.warning;
        }
        return SessionStates.none;
    };
    SessionTimer.prototype.getWarningTimeLeft = function () {
        var _a;
        var warning = this.config.warning;
        var now = new Date().getTime();
        var storedTimer = Number((_a = localStorage.getItem(sessionTimerKey)) !== null && _a !== void 0 ? _a : now);
        var warningTimeLeft = storedTimer + warning - now;
        return warningTimeLeft;
    };
    SessionTimer.prototype.getSessionTimeoutLeft = function () {
        var _a;
        var _b = this.config, timeout = _b.timeout, warning = _b.warning;
        var now = new Date().getTime();
        var storedTimer = Number((_a = localStorage.getItem(sessionTimerKey)) !== null && _a !== void 0 ? _a : now);
        var timeoutTimeLeft = storedTimer + warning + timeout - now;
        return timeoutTimeLeft;
    };
    return SessionTimer;
}());

var eventStorageKey = '_auth-client-event';
/**
 * The VisAuthService is the home of all major auth related operations in the VIS Auth Client.
 */
// eslint-disable-next-line import/prefer-default-export
var VisAuthService = /** @class */ (function () {
    /**
     * @param config configuration object for AuthService
     * @param router override app route changes made by the AuthService (React Router)
     */
    function VisAuthService(config, router, sessionTimer) {
        if (router === void 0) { router = window.location; }
        if (sessionTimer === void 0) { sessionTimer = config.session && new SessionTimer(config.session); }
        this.config = config;
        this.router = router;
        this.sessionTimer = sessionTimer;
        this.authState = {
            state: AuthStates.authenticating,
            sessionState: SessionStates.none,
        };
        this.subscribers = [];
        this.activeWindow = document.hasFocus();
        this.initializing = true;
        this.storage = new StorageService(config.tokenStorage);
        this.setupStorageListener();
        this.setupTimerListeners();
    }
    Object.defineProperty(VisAuthService.prototype, "state", {
        /**
         * Object with related auth values.
         *
         * Use `subscribe` to receive updates to `authState`
         */
        get: function () {
            return this.authState;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Subscribe to updates to authState
     *
     * @param subscriber Function that will be called when a new authState is set.
     * @returns Cleanup function that can be called to remove the subscription.
     */
    VisAuthService.prototype.subscribe = function (subscriber) {
        var _this = this;
        this.subscribers.push(subscriber);
        return function () {
            _this.subscribers = _this.subscribers.filter(function (fn) { return fn !== subscriber; });
        };
    };
    /**
     * Removes token and sets auth state to `unauthenticated`
     */
    VisAuthService.prototype.logout = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, , 2, 3]);
                        return [4 /*yield*/, ((_b = (_a = this.config.hooks) === null || _a === void 0 ? void 0 : _a.onLogout) === null || _b === void 0 ? void 0 : _b.call(_a, (_c = this.authState.accessToken) !== null && _c !== void 0 ? _c : '', this.state.user))];
                    case 1:
                        _d.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.setAuthState({
                            state: this.config.logoutUri ? AuthStates.logout : AuthStates.unauthenticated,
                            sessionState: SessionStates.none,
                        });
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Refreshes token and calls `onSessionUpdate`.
     */
    VisAuthService.prototype.refresh = function (token, user, skipSession) {
        var _a, _b, _c, _d, _e;
        if (token === void 0) { token = null; }
        if (user === void 0) { user = null; }
        if (skipSession === void 0) { skipSession = false; }
        return __awaiter(this, void 0, void 0, function () {
            var newToken, newUser, unloading_1, setUnloading, _f, _g, _h;
            var _j, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        newToken = (_a = token !== null && token !== void 0 ? token : this.state.accessToken) !== null && _a !== void 0 ? _a : '';
                        newUser = user !== null && user !== void 0 ? user : this.state.user;
                        if (!newToken) {
                            this.setAuthState({
                                state: AuthStates.unauthenticated,
                                sessionState: SessionStates.none,
                            });
                            return [2 /*return*/];
                        }
                        if (!!skipSession) return [3 /*break*/, 7];
                        unloading_1 = false;
                        setUnloading = function () {
                            unloading_1 = true;
                        };
                        window.addEventListener('beforeunload', setUnloading);
                        if (this.sessionTimer) {
                            this.sessionTimer.clearSessionTimers();
                        }
                        _l.label = 1;
                    case 1:
                        _l.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, Promise.all([
                                this.refreshGatewaySession(newToken),
                                (_c = (_b = this.config.hooks) === null || _b === void 0 ? void 0 : _b.onSessionUpdate) === null || _c === void 0 ? void 0 : _c.call(_b, newToken, newUser),
                            ])];
                    case 2:
                        _l.sent();
                        _f = this.setAuthState;
                        _j = {
                            state: AuthStates.authenticated,
                            sessionState: SessionStates.valid,
                            accessToken: newToken,
                            user: newUser
                        };
                        return [4 /*yield*/, this.getTokenInfo(newToken)];
                    case 3:
                        _f.apply(this, [(_j.audience = (_d = (_l.sent())) === null || _d === void 0 ? void 0 : _d.aud,
                                _j)]);
                        return [3 /*break*/, 6];
                    case 4:
                        _g = _l.sent();
                        if (unloading_1) {
                            return [2 /*return*/];
                        }
                        this.setAuthState({
                            state: AuthStates.unauthenticated,
                            sessionState: SessionStates.none,
                        });
                        return [2 /*return*/];
                    case 5:
                        window.removeEventListener('beforeunload', setUnloading);
                        return [7 /*endfinally*/];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        _h = this.setAuthState;
                        _k = {
                            state: AuthStates.authenticated,
                            sessionState: SessionStates.valid,
                            accessToken: newToken,
                            user: newUser
                        };
                        return [4 /*yield*/, this.getTokenInfo(newToken)];
                    case 8:
                        _h.apply(this, [(_k.audience = (_e = (_l.sent())) === null || _e === void 0 ? void 0 : _e.aud,
                                _k)]);
                        _l.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Redirects user to OAuth2 /authorize endpoint
     */
    VisAuthService.prototype.authorizeRedirect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var localPath, codes, _a, clientId, issuer, redirectUri, scope, role, landingPage, authorizeUrl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        localPath = window.location.pathname + window.location.search + window.location.hash;
                        this.storage.setSecureRouterReferrerPath(localPath);
                        return [4 /*yield*/, generatePkceCodes()];
                    case 1:
                        codes = _b.sent();
                        this.storage.setPkceCodes(codes, true);
                        _a = this.config, clientId = _a.clientId, issuer = _a.issuer, redirectUri = _a.redirectUri, scope = _a.scope, role = _a.role, landingPage = _a.landingPage;
                        authorizeUrl = buildAuthorizeUrl(clientId, issuer, redirectUri, codes.codeState, codes.codeChallenge, scope, role, landingPage);
                        window.location.href = authorizeUrl;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Redirects user to login.gov /openid_connect/logout endpoint
     * @param state (optional)
     */
    VisAuthService.prototype.mfaLogoutRedirect = function (state) {
        var _a = this.config, loginDotGovUrl = _a.loginDotGovUrl, clientId = _a.clientId, logoutUri = _a.logoutUri;
        if (logoutUri) {
            var redirectUri = typeof logoutUri === 'function' ? logoutUri() : logoutUri;
            var mfalogoutUrl = buildMFALogoutUrl(loginDotGovUrl, clientId, redirectUri, state || false);
            window.location.href = mfalogoutUrl;
        }
        else {
            throw new AuthError('MFA logout redirect failed, missing post_logout_redirect_uri');
        }
    };
    VisAuthService.prototype.claimUserSession = function (userId, app) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var blockUnload, issuer, claimUserTokenRequest, claimUserTokenResponse, _d, _e, claimUserToken, claimedUser, _f;
            var _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        blockUnload = function (e) { return e.preventDefault(); };
                        window.addEventListener('unload', blockUnload);
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, , 9, 10]);
                        issuer = this.config.issuer;
                        if (!((_a = this.authState) === null || _a === void 0 ? void 0 : _a.accessToken)) {
                            throw new AuthError('invalid token, cannot claim user');
                        }
                        claimUserTokenRequest = buildClaimUserTokenRequest(userId, app, this.authState.accessToken, issuer);
                        return [4 /*yield*/, fetch(claimUserTokenRequest)];
                    case 2:
                        claimUserTokenResponse = _h.sent();
                        if (!!claimUserTokenResponse.ok) return [3 /*break*/, 4];
                        _d = AuthError.bind;
                        return [4 /*yield*/, claimUserTokenResponse.text()];
                    case 3: throw new (_d.apply(AuthError, [void 0, _h.sent()]))();
                    case 4: return [4 /*yield*/, claimUserTokenResponse.json()];
                    case 5:
                        _e = (_h.sent()), claimUserToken = _e.access_token, claimedUser = _e.user;
                        _f = this.setAuthState;
                        _g = {
                            state: AuthStates.authenticated,
                            sessionState: SessionStates.valid,
                            accessToken: claimUserToken,
                            user: claimedUser
                        };
                        return [4 /*yield*/, this.getTokenInfo(claimUserToken)];
                    case 6:
                        _f.apply(this, [(_g.audience = (_b = (_h.sent())) === null || _b === void 0 ? void 0 : _b.aud,
                                _g)]);
                        if (!((_c = this.config.hooks) === null || _c === void 0 ? void 0 : _c.onTokenReceived)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.config.hooks.onTokenReceived(claimUserToken, claimedUser)];
                    case 7:
                        _h.sent();
                        _h.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        window.removeEventListener('unload', blockUnload);
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets a migration token (technically access_token) oidc/authorize -> v1/token
     * @param clientId
     * @param scope
     * @param username
     * @param password
     * @returns migrationToken and associated user
     */
    VisAuthService.prototype.getMigrationToken = function (params) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var clientId, scope, username, password, _c, redirectUri, issuer, codes, authorizationCode, migrationToken, user, authRequest, authResponse, responseText, tokenRequest, tokenResponse, tokenObj, e_1;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        clientId = params.clientId, scope = params.scope, username = params.username, password = params.password;
                        _c = this.config, redirectUri = _c.redirectUri, issuer = _c.issuer;
                        return [4 /*yield*/, generatePkceCodes()];
                    case 1:
                        codes = _e.sent();
                        this.storage.setPkceCodes(codes);
                        authorizationCode = '';
                        migrationToken = '';
                        authRequest = buildOidcAuthorizePasswordRequest({
                            clientId: clientId,
                            redirectUri: redirectUri,
                            username: username,
                            password: password,
                            codeChallenge: codes.codeChallenge,
                            scope: scope,
                        });
                        return [4 /*yield*/, fetch(authRequest)];
                    case 2:
                        authResponse = _e.sent();
                        if (!!authResponse.ok) return [3 /*break*/, 4];
                        if (authResponse.status === 401)
                            throw new AuthError('User ID and/or password is incorrect.');
                        return [4 /*yield*/, authResponse.text()];
                    case 3:
                        responseText = _e.sent();
                        if (authResponse.status === 400 && responseText.includes('USER_NOT_AUTHORIZED_FOR_APP'))
                            throw new AuthError('You do not have access to this application. Check to ensure you are accessing the correct program and try logging in again.');
                        if (authResponse.status === 400 && responseText.includes('USER_IS_MFA_ENABLED'))
                            throw new AuthError('This account has already been migrated to sign in with Login.gov.');
                        throw new AuthError('Something went wrong. Please wait a few minutes and try again. If the problem continues, contact your Administrator.');
                    case 4: return [4 /*yield*/, authResponse.json()];
                    case 5:
                        // eslint-disable-next-line prefer-const
                        (_d = (_e.sent()), authorizationCode = _d.authorizationCode, user = _d.user);
                        if (user.webServiceEnabled)
                            throw new AuthError('Web Service user accounts cannot login to this application. Try using a different user account to login.');
                        if (((_a = user.roles) === null || _a === void 0 ? void 0 : _a.includes('ENROLLMENT')) || ((_b = user.roles) === null || _b === void 0 ? void 0 : _b.includes('ONBOARDING')))
                            throw new AuthError('Users of this role are not allowed to migrate to MFA.');
                        if (user.status === 'LOCKED' || user.status === 'DEACTIVATED') {
                            throw new AuthError('This account has been locked/deactivated. Please reset your password to continue.');
                        }
                        tokenRequest = buildTokenRequest(clientId, issuer, redirectUri, authorizationCode, codes.codeVerifier, scope);
                        _e.label = 6;
                    case 6:
                        _e.trys.push([6, 9, , 10]);
                        return [4 /*yield*/, fetch(tokenRequest)];
                    case 7:
                        tokenResponse = _e.sent();
                        if (!tokenResponse.ok) {
                            throw new AuthError('Login unsuccessful.');
                        }
                        return [4 /*yield*/, tokenResponse.json()];
                    case 8:
                        tokenObj = (_e.sent());
                        migrationToken = tokenObj.access_token;
                        return [3 /*break*/, 10];
                    case 9:
                        e_1 = _e.sent();
                        throw new AuthError('Login unsuccessful.');
                    case 10: 
                    // Step 3 return authorizationToken and user
                    return [2 /*return*/, {
                            migrationToken: migrationToken,
                            user: user,
                        }];
                }
            });
        });
    };
    /**
     * Redirects user to OAuth2 /authorize-migrate endpoint
     */
    VisAuthService.prototype.authorizeMigrateRedirect = function (token, clientId, scope, redirectUri) {
        var _a;
        if (redirectUri === void 0) { redirectUri = this.config.redirectUri; }
        return __awaiter(this, void 0, void 0, function () {
            var authToken, localPath, codes, _b, issuer, role, landingPage, migrationStateAppendUserIdRequest, response, _c, stateParam, authorizeMigrateUrl;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        authToken = token !== null && token !== void 0 ? token : this.state.accessToken;
                        localPath = window.location.pathname + window.location.search + window.location.hash;
                        this.storage.setSecureRouterReferrerPath(localPath);
                        return [4 /*yield*/, generatePkceCodes()];
                    case 1:
                        codes = _d.sent();
                        this.storage.setPkceCodes(codes, true);
                        _b = this.config, issuer = _b.issuer, role = _b.role, landingPage = _b.landingPage;
                        migrationStateAppendUserIdRequest = buildMigrationStateAppendUserIdRequest(authToken, issuer, codes.codeState);
                        return [4 /*yield*/, fetch(migrationStateAppendUserIdRequest)];
                    case 2:
                        response = _d.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        _c = AuthError.bind;
                        return [4 /*yield*/, response.text()];
                    case 3: throw new (_c.apply(AuthError, [void 0, (_a = (_d.sent())) !== null && _a !== void 0 ? _a : 'authorize migrate failed.']))();
                    case 4: return [4 /*yield*/, response.json()];
                    case 5:
                        stateParam = (_d.sent()).state;
                        authorizeMigrateUrl = buildAuthorizeUrl(clientId, issuer, redirectUri, stateParam, codes.codeChallenge, scope, role, landingPage);
                        window.location.href = authorizeMigrateUrl;
                        return [2 /*return*/];
                }
            });
        });
    };
    VisAuthService.prototype.handleOneTimeCodeAuthentication = function (otc) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var issuer, oneTimeCodeTokenRequest, tokenResponse, _d, tokenBody, accessToken, _e;
            var _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        issuer = this.config.issuer;
                        this.storage.removeToken();
                        this.storage.removeUser();
                        this.storage.removeSecureRouterReferrerPath();
                        this.storage.removePkceCodes();
                        oneTimeCodeTokenRequest = buildOneTimeCodeTokenRequest(otc, issuer);
                        return [4 /*yield*/, fetch(oneTimeCodeTokenRequest)];
                    case 1:
                        tokenResponse = _g.sent();
                        if (!!tokenResponse.ok) return [3 /*break*/, 3];
                        _d = AuthError.bind;
                        return [4 /*yield*/, tokenResponse.text()];
                    case 2: throw new (_d.apply(AuthError, [void 0, (_a = (_g.sent())) !== null && _a !== void 0 ? _a : 'one time code authentication failed.']))();
                    case 3: return [4 /*yield*/, tokenResponse.json()];
                    case 4:
                        tokenBody = (_g.sent());
                        accessToken = tokenBody.access_token;
                        _e = this.setAuthState;
                        _f = {
                            state: AuthStates.authenticated,
                            sessionState: SessionStates.valid,
                            accessToken: accessToken
                        };
                        return [4 /*yield*/, this.getTokenInfo(accessToken)];
                    case 5:
                        _e.apply(this, [(_f.audience = (_b = (_g.sent())) === null || _b === void 0 ? void 0 : _b.aud,
                                _f)]);
                        if (!((_c = this.config.hooks) === null || _c === void 0 ? void 0 : _c.onTokenReceived)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.config.hooks.onTokenReceived(accessToken)];
                    case 6:
                        _g.sent();
                        _g.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handles OAuth2 flow when loading the page.
     */
    VisAuthService.prototype.handleAuthentication = function () {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var stateDelimiter, urlParams, code, _e, codeVerifier, codeState, state, codeStateToken, location_1, _f, accessToken, user, _g, error_1, error;
            var _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        stateDelimiter = '.';
                        urlParams = new URLSearchParams(window.location.search);
                        code = urlParams.get('code');
                        console.log('code :', code);
                        _j.label = 1;
                    case 1:
                        _j.trys.push([1, , 14, 15]);
                        if (!code) return [3 /*break*/, 12];
                        _e = this.storage.removePkceCodes(), codeVerifier = _e.codeVerifier, codeState = _e.codeState;
                        state = (_a = urlParams.get('state')) !== null && _a !== void 0 ? _a : '';
                        codeStateToken = state.split(stateDelimiter)[0];
                        console.log('codeState === codeStateToken :', codeState === codeStateToken, codeState, codeStateToken);
                        if (codeState !== codeStateToken) {
                            this.setAuthState({
                                state: AuthStates.unauthenticated,
                                sessionState: SessionStates.none,
                                error: new AuthError('Invalid State'),
                            });
                            this.router.replace(this.config.errorPath);
                            return [2 /*return*/];
                        }
                        location_1 = this.storage.removeSecureRouterReferrerPath();
                        console.log('location :', location_1);
                        _j.label = 2;
                    case 2:
                        _j.trys.push([2, 7, , 8]);
                        console.log('TRY TOKEN EXCHANGE');
                        return [4 /*yield*/, this.tokenExchange(code, codeVerifier, state)];
                    case 3:
                        _f = _j.sent(), accessToken = _f.access_token, user = _f.user;
                        console.log('accessToken :', accessToken, user);
                        if (!((_b = this.config.hooks) === null || _b === void 0 ? void 0 : _b.onTokenReceived)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.config.hooks.onTokenReceived(accessToken, user)];
                    case 4:
                        _j.sent();
                        _j.label = 5;
                    case 5:
                        // TODO Validate response
                        _g = this.setAuthState;
                        _h = {
                            state: AuthStates.authenticated,
                            sessionState: SessionStates.valid,
                            accessToken: accessToken,
                            user: user,
                            secureRouterReferrerPath: location_1
                        };
                        return [4 /*yield*/, this.getTokenInfo(accessToken)];
                    case 6:
                        // TODO Validate response
                        _g.apply(this, [(_h.audience = (_c = (_j.sent())) === null || _c === void 0 ? void 0 : _c.aud,
                                _h)]);
                        return [3 /*break*/, 8];
                    case 7:
                        error_1 = _j.sent();
                        console.log('ERROR, UNAUTHED');
                        this.setAuthState({
                            state: AuthStates.unauthenticated,
                            sessionState: SessionStates.none,
                            error: error_1 || new AuthError('Token failed to fetch.'),
                        });
                        this.router.replace(this.config.errorPath);
                        return [2 /*return*/];
                    case 8:
                        console.log('REPLACE', location_1);
                        if (!((_d = this.config.hooks) === null || _d === void 0 ? void 0 : _d.onHandleAuthentication)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.config.hooks.onHandleAuthentication(location_1)];
                    case 9:
                        _j.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        this.router.replace(location_1);
                        _j.label = 11;
                    case 11: return [2 /*return*/];
                    case 12:
                        error = urlParams.get('error');
                        if (error) {
                            this.setAuthState({
                                state: AuthStates.unauthenticated,
                                sessionState: SessionStates.none,
                                error: new AuthError(error),
                            });
                            this.router.replace(this.config.errorPath);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.restoreSession()];
                    case 13:
                        _j.sent();
                        return [3 /*break*/, 15];
                    case 14:
                        this.setInitialized();
                        return [7 /*endfinally*/];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    VisAuthService.prototype.getTokenInfo = function (token) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, tokenInfoRequest, tokenInfoResponse, tokenInfoResponseBody, textResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        accessToken = (_a = token !== null && token !== void 0 ? token : this.authState.accessToken) !== null && _a !== void 0 ? _a : '';
                        tokenInfoRequest = buildGetTokenInfoRequest(accessToken);
                        return [4 /*yield*/, fetch(tokenInfoRequest)];
                    case 1:
                        tokenInfoResponse = _b.sent();
                        if (!tokenInfoResponse.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, tokenInfoResponse.json()];
                    case 2:
                        tokenInfoResponseBody = (_b.sent());
                        return [2 /*return*/, tokenInfoResponseBody];
                    case 3: return [4 /*yield*/, tokenInfoResponse.text()];
                    case 4:
                        textResponse = _b.sent();
                        throw new AuthError(textResponse);
                }
            });
        });
    };
    VisAuthService.prototype.setAuthState = function (state) {
        var previousState = this.authState.state;
        this.newStateEffects(state);
        this.authState = state;
        this.subscribers.forEach(function (subscriber) { return subscriber(state); });
        if (state.state !== previousState) {
            localStorage.setItem(eventStorageKey, "".concat(state.state, ":").concat(Math.random().toString()));
        }
    };
    VisAuthService.prototype.newStateEffects = function (state) {
        if (state.accessToken) {
            // Valid session, push back timeout
            if (state.sessionState === SessionStates.valid) {
                this.setupSessionWarning(state.accessToken);
            }
            // New token, store it
            if (this.authState.accessToken !== state.accessToken) {
                this.storage.setToken(state.accessToken);
            }
            // New user, store it
            if (state.user) {
                this.storage.setUser(state.user);
            }
        }
        else {
            // Logout or timeout
            if (this.sessionTimer) {
                this.sessionTimer.clearSessionTimers();
            }
            this.storage.removeToken();
            this.storage.removeUser();
            if (state.state === AuthStates.logout && this.config.logoutUri) {
                var logoutUri = typeof this.config.logoutUri === 'function' ? this.config.logoutUri() : this.config.logoutUri;
                window.location.href = logoutUri;
            }
        }
    };
    VisAuthService.prototype.restoreSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = this.storage.getToken();
                        user = this.storage.getUser();
                        if (!token) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.refresh(token, user)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.setAuthState({
                            state: AuthStates.unauthenticated,
                            sessionState: SessionStates.none,
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VisAuthService.prototype.tokenExchange = function (code, codeVerifier, state) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, clientId, issuer, redirectUri, scope, tokenRequest, response, textResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.config, clientId = _a.clientId, issuer = _a.issuer, redirectUri = _a.redirectUri, scope = _a.scope;
                        tokenRequest = buildTokenRequest(clientId, issuer, redirectUri, code, codeVerifier, scope, state);
                        return [4 /*yield*/, fetch(tokenRequest)];
                    case 1:
                        response = _b.sent();
                        console.log('TOKEN EXCHANGE RESPONSE', response);
                        if (response.ok) {
                            // eslint-disable-next-line camelcase
                            return [2 /*return*/, response.json()];
                        }
                        return [4 /*yield*/, response.text()];
                    case 2:
                        textResponse = _b.sent();
                        throw new AuthError(textResponse);
                }
            });
        });
    };
    VisAuthService.prototype.setInitialized = function () {
        var _this = this;
        setTimeout(function () {
            _this.initializing = false;
        }, 0);
    };
    /**
     * Use this function during normal operations to periodically
     * delay the session timeout warning.
     */
    VisAuthService.prototype.delaySessionWarning = function () {
        return __awaiter(this, void 0, void 0, function () {
            var throttle;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.initializing) {
                            return [2 /*return*/];
                        }
                        if (this.authState.sessionState !== SessionStates.valid) {
                            return [2 /*return*/];
                        }
                        throttle = (this.config.session || {}).throttle;
                        if (throttle) {
                            if (this.throttleTimer) {
                                return [2 /*return*/];
                            }
                            this.throttleTimer = window.setTimeout(function () {
                                _this.throttleTimer = undefined;
                            }, throttle);
                        }
                        return [4 /*yield*/, this.refresh(this.authState.accessToken, this.authState.user)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    VisAuthService.prototype.setupSessionWarning = function (token) {
        var _this = this;
        if (this.sessionTimer && this.activeWindow) {
            this.sessionTimer.setupSessionWarning(function (timeLeft) { return _this.onUpdateWarningTimer(timeLeft); }, function () {
                _this.sessionTimeout(token).finally(function () {
                    // remove no floating promise eslint error
                });
            });
        }
    };
    VisAuthService.prototype.sessionTimeout = function (token) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, , 2, 3]);
                        return [4 /*yield*/, ((_b = (_a = this.config.hooks) === null || _a === void 0 ? void 0 : _a.onLogout) === null || _b === void 0 ? void 0 : _b.call(_a, token, this.state.user))];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.setAuthState({
                            state: this.config.logoutUri ? AuthStates.logout : AuthStates.unauthenticated,
                            sessionState: SessionStates.timeout,
                        });
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VisAuthService.prototype.refreshGatewaySession = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var refreshUri, refreshRequest, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        refreshUri = this.config.refreshUri === undefined ? '/api/refresh_session' : this.config.refreshUri;
                        if (refreshUri === false) {
                            return [2 /*return*/];
                        }
                        refreshRequest = buildRefreshSessionRequest(token, refreshUri);
                        return [4 /*yield*/, fetch(refreshRequest)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new AuthError('refreshGatewaySession failed.');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    VisAuthService.prototype.setupStorageListener = function () {
        var _this = this;
        window.addEventListener('storage', function (event) {
            var _a;
            if (event.key === eventStorageKey) {
                var state = (_a = event.newValue) === null || _a === void 0 ? void 0 : _a.substring(0, event.newValue.indexOf(':'));
                switch (state) {
                    case AuthStates.unauthenticated: {
                        if (_this.authState.state !== AuthStates.unauthenticated) {
                            _this.setAuthState({
                                state: AuthStates.unauthenticated,
                                sessionState: SessionStates.none,
                            });
                        }
                        break;
                    }
                    case AuthStates.authenticated: {
                        var token = _this.storage.getToken();
                        var user = _this.storage.getUser();
                        var skipSession = true;
                        if (token) {
                            _this.refresh(token, user, skipSession).catch(function () {
                                // refresh doesn't await anything when skipSession = true
                            });
                        }
                        break;
                    }
                }
            }
        });
    };
    VisAuthService.prototype.onUpdateWarningTimer = function (timeLeft) {
        this.setAuthState(__assign(__assign({}, this.state), { timeLeft: timeLeft, sessionState: SessionStates.warning }));
    };
    VisAuthService.prototype.setupTimerListeners = function () {
        var _this = this;
        var sessionTimer = this.sessionTimer;
        if (sessionTimer) {
            window.addEventListener('blur', function () {
                _this.activeWindow = false;
                sessionTimer.clearSessionTimers(true);
            });
            window.addEventListener('focus', function () {
                _this.activeWindow = true;
                var localAccessToken = _this.authState.accessToken;
                if (localAccessToken && _this.sessionTimer && _this.activeWindow) {
                    var sessionState = _this.sessionTimer.restoreSessionTimer(function (timeLeft) { return _this.onUpdateWarningTimer(timeLeft); }, function () {
                        _this.sessionTimeout(localAccessToken).finally(function () {
                            // remove no floating promise eslint error
                        });
                    });
                    if (SessionStates.none === sessionState) {
                        _this.logout().finally(function () {
                            // logout errors should be handled by onLogout hook
                        });
                    }
                    else if (SessionStates.valid === sessionState) {
                        _this.setAuthState(__assign(__assign({}, _this.state), { sessionState: SessionStates.valid }));
                    }
                }
            });
        }
    };
    return VisAuthService;
}());

var Audience;
(function (Audience) {
    Audience["everify"] = "Everify";
    Audience["save"] = "Save";
    Audience["everifyEmail"] = "Everify-Email";
    Audience["saveEmail"] = "Save-Email";
    Audience["visAdmin"] = "VISAdmin";
    Audience["nextGen"] = "NextGen";
    Audience["everifyEnrollment"] = "everify_enrollment";
    Audience["saveEnrollment"] = "save_enrollment";
})(Audience || (Audience = {}));

export { Audience, AuthError, AuthErrorName, AuthStates, SessionStates, SessionTimer, StorageService, VisAuthService };
//# sourceMappingURL=index.es.js.map
